/**
 * /app/$tenantSlug/performance/my-results/$cycleId — one closed cycle's
 * results for the signed-in employee (2026-10): final rating, manager's
 * review, own self review. The "Your review results are available"
 * notification links here.
 */

import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useMyResult } from "@/hooks/use-performance";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { MyResultDetailView } from "@/components/performance/my-results";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/my-results/$cycleId",
)({
  component: MyResultDetailRoute,
});

function MyResultDetailRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const { cycleId } = Route.useParams();
  const id = Number(cycleId);
  // The cycle's name titles the page (Results › <cycle>).
  const resultQ = useMyResult(id);
  return (
    <PerformanceModuleShell
      title={resultQ.data?.cycle.name || "Results"}
      description="Your final rating, your manager's review and your self review for this cycle."
      actions={
        <Button asChild variant="outline" className="gap-1.5 lg:hidden">
          <Link to="/app/$tenantSlug/performance/my-results" params={{ tenantSlug }}>
            <ArrowLeft className="h-4 w-4" />
            All Results
          </Link>
        </Button>
      }
    >
      <PerformanceFeatureGate>
        {Number.isFinite(id) && id > 0 ? (
          <MyResultDetailView cycleId={id} />
        ) : (
          <p className="text-sm text-muted-foreground">Invalid cycle id.</p>
        )}
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
